import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SecurityGroups } from '@morningstar/shared/auth';
import { TokenService } from '@morningstar/shared/auth';
import { UserStatus } from '../../../../../../libs/shared/auth/src/lib/user-status';

@Component({
  selector: 'wsg-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  constructor(private tokenService: TokenService,
              private router: Router,
              private route: ActivatedRoute) { }

  ngOnInit() {
    this.tokenService.deleteToken();
    this.tokenService.userStatus.next(new UserStatus(false, SecurityGroups.None));

    const returnUrl = this.route.snapshot.queryParams['returnUrl'];

    this.router.navigate(['/'], { queryParams: { returnUrl: returnUrl }});
  }
}
